<template>
  <div class="background" :style="{ backgroundImage: getBackgroundImage, backgroundColor: getBackgroundColor }"></div>
</template>

<script>
import { mapGetters } from 'vuex';
import bg_1 from '../../assets/backgrounds/b_1.jpg'
import bg_2 from '../../assets/backgrounds/b_2.jpg'
import bg_3 from '../../assets/backgrounds/b_3.jpg'
import bg_4 from '../../assets/backgrounds/b_4.jpg'
import bg_5 from '../../assets/backgrounds/b_5.jpg'
import bg_6 from '../../assets/backgrounds/b_6.jpg'
import bg_7 from '../../assets/backgrounds/b_7.jpg'
import bg_8 from '../../assets/backgrounds/b_8.jpg'
import bg_9 from '../../assets/backgrounds/b_9.jpg'
import bg_10 from '../../assets/backgrounds/b_10.jpg'
import bg_11 from '../../assets/backgrounds/b_11.jpg'
import bg_12 from '../../assets/backgrounds/b_12.jpg'
import bg_13 from '../../assets/backgrounds/b_13.jpg'
import bg_14 from '../../assets/backgrounds/b_14.jpg'
import bg_15 from '../../assets/backgrounds/b_15.jpg'
import bg_16 from '../../assets/backgrounds/b_16.jpg'
import bg_17 from '../../assets/backgrounds/b_17.jpg'
import bg_18 from '../../assets/backgrounds/b_18.jpg'
import bg_19 from '../../assets/backgrounds/b_19.jpg'
import bg_20 from '../../assets/backgrounds/b_20.jpg'
import bg_21 from '../../assets/backgrounds/b_21.jpg'

export default {
  name: 'Background',
  data() {
    return {
      bg_1,
      bg_2,
      bg_3,
      bg_4,
      bg_5,
      bg_6,
      bg_7,
      bg_8,
      bg_9,
      bg_10,
      bg_11,
      bg_12,
      bg_13,
      bg_14,
      bg_15,
      bg_16,
      bg_17,
      bg_18,
      bg_19,
      bg_20,
      bg_21,
    }
  },
  computed: {
    ...mapGetters('recording', ['getCurrentBotBg', 'getBackgroundStore']),
    getBackgroundImage() {
      if(this.getCurrentBotBg.type == 'stock') {
        switch(this.getCurrentBotBg.data) {
          case 1: return `url(${this.bg_1})`;
          case 2: return `url(${this.bg_2})`;
          case 3: return `url(${this.bg_3})`;
          case 4: return `url(${this.bg_4})`;
          case 5: return `url(${this.bg_5})`;
          case 6: return `url(${this.bg_6})`;
          case 7: return `url(${this.bg_7})`;
          case 8: return `url(${this.bg_8})`;
          case 9: return `url(${this.bg_9})`;
          case 10: return `url(${this.bg_10})`;
          case 11: return `url(${this.bg_11})`;
          case 12: return `url(${this.bg_12})`;
          case 13: return `url(${this.bg_13})`;
          case 14: return `url(${this.bg_14})`;
          case 15: return `url(${this.bg_15})`;
          case 16: return `url(${this.bg_16})`;
          case 17: return `url(${this.bg_17})`;
          case 18: return `url(${this.bg_18})`;
          case 19: return `url(${this.bg_19})`;
          case 20: return `url(${this.bg_20})`;
          case 21: return `url(${this.bg_21})`;
          default: return '';
        }
      } else if(this.getCurrentBotBg.type == 'upload') {
        let result = this.getBackgroundStore.find(object => {
          return object.name == this.getCurrentBotBg.data;
        })
        return `url(${result.data})`;
      } else {
        return '';
      }
    },
    getBackgroundColor() {
      if(this.getCurrentBotBg.type != 'color') {
        return '';
      } else {
        return this.getCurrentBotBg.data.hex;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.background {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;

  @keyframes appear {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>